var app = angular.module('leonardo');

var OnDemandSubCategoryService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('on-demand-subcategories', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('on-demand-subcategories', false, function(instruction) {
      instruction.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return instruction;
    });
  });

  service.bulkObject = function() {
    return {
      name: '',
      image: null,
      description: ''
    };
  };


  return service;
};

app.factory('OnDemandSubCategoryService', ['BaseRestService', 'Restangular', OnDemandSubCategoryService]);
